import { RecentlyViewed } from '@theme/recently-viewed-products';

class PatteraProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-pattera-recs-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-pattera-recs-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#setActiveTab(tab.dataset.patteraRecsTab));
    });

    this.#loadRelatedProducts();
    this.#loadRecentlyViewedProducts();
  }

  #setActiveTab(tabName) {
    if (!tabName) return;

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.patteraRecsTab === tabName;
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.patteraRecsPanel !== tabName;
    });
  }

  async #loadRelatedProducts() {
    const { productId, sectionId, recommendationsUrl, maxProducts } = this.dataset;
    const panel = this.querySelector('[data-pattera-recs-panel="related"]');
    const track = panel?.querySelector('[data-pattera-recs-track]');

    if (!productId || !sectionId || !recommendationsUrl || !track) return;
    if (track.dataset.loaded === 'true') return;

    const url = new URL(recommendationsUrl, window.location.origin);
    url.searchParams.set('limit', maxProducts || '5');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('intent', 'related');

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const renderedTrack = parsed.querySelector(`#pattera-product-recs-${sectionId} [data-pattera-recs-panel="related"] [data-pattera-recs-track]`);

      if (renderedTrack?.children.length) {
        track.replaceChildren(...Array.from(renderedTrack.children));
        track.dataset.loaded = 'true';
      }
    } catch (error) {
      console.error('Pattera related products error:', error);
    }
  }

  async #loadRecentlyViewedProducts() {
    const { productId, sectionId, searchUrl, maxProducts } = this.dataset;
    const panel = this.querySelector('[data-pattera-recs-panel="recently-viewed"]');
    const track = panel?.querySelector('[data-pattera-recs-track]');
    const emptyState = panel?.querySelector('[data-pattera-recs-empty]');

    if (!sectionId || !searchUrl || !track) return;

    const viewedProducts = RecentlyViewed.getProducts()
      .filter((id) => id !== productId)
      .slice(0, Number(maxProducts || 5));

    if (viewedProducts.length === 0) {
      emptyState?.removeAttribute('hidden');
      return;
    }

    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const renderedTrack = parsed.querySelector(`#pattera-product-recs-${sectionId} [data-pattera-recs-panel="recently-viewed"] [data-pattera-recs-track]`);

      if (renderedTrack?.children.length) {
        track.replaceChildren(...Array.from(renderedTrack.children));
        track.dataset.loaded = 'true';
        emptyState?.setAttribute('hidden', '');
      } else {
        emptyState?.removeAttribute('hidden');
      }
    } catch (error) {
      console.error('Pattera recently viewed products error:', error);
    }
  }
}

if (!customElements.get('pattera-product-recommendations')) {
  customElements.define('pattera-product-recommendations', PatteraProductRecommendations);
}
